import { BottomBar } from './BottomBar';
import { BgBlurredText } from './BgBlurredText';
import { Contents } from './Contents';
import { ProductWizard } from 'components/shared/ProductWizard';
import { TechnicalSpecs } from './TechnicalSpecs';
import { SolidBgTextSection } from './SolidBgTextSection';
import { Capabilities } from 'components/ring-air/Capabilities';
import { FAQSection } from 'components/shared/FAQSection';
import { dieselRingFaqDataPricingPage } from 'content/products/dieselRing';

export * from './ProductSelectionSection';
export * from './BottomBar';

export const PageContent = () => (
  <>
    <Contents />
    <BgBlurredText />
    <TechnicalSpecs imageBackgroundColor="#ffffff" />
    <SolidBgTextSection />
    <Capabilities />
    <ProductWizard title="Still unsure if Diesel Ultrahuman Ring is right for you?" />
    <FAQSection faqData={dieselRingFaqDataPricingPage} />
    <BottomBar />
  </>
);
